import "core-js/modules/es.array.push.js";
import { useStore } from "vuex";
import { useRouter, useRoute } from 'vue-router';
import { ref, watch, reactive, computed, onBeforeMount } from "vue";
import ClipboardBtn from "@/components/common/ClipboardBtn.vue";
import { Toast } from 'vant';
import * as API from '@/api';
export default {
  name: "PalcodePopup",
  components: {
    ClipboardBtn
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const state = reactive({
      isGetData: false,
      tabValue: 1,
      // 1: 我是推荐人; 2: 我是被推荐人
      palcodeValue: ''
    });
    const showPalcodePopup = computed(() => store.state.common.palcodePopup.show);
    const isInIframe = window.frameElement;
    const redirect = () => {
      if (showPalcodePopup.value) {
        store.dispatch('common/showPalcodePopup', {
          show: false
        }); // 关闭弹窗
      } else {
        if (isInIframe) {
          parent.postMessage({
            vueIframe: {
              elemtId: 'i-recommend',
              action: 'close'
            }
          });
        } else if (history.length > 1) history.back();else location.href = '/';
      }
    };
    const init = async () => {
      if (!store.state.user.isLogin) {
        redirect();
        return;
      }
      // 确认验证码
      const palcodeInfoData = await store.dispatch('user/getPalcodeInfo');
      if (!palcodeInfoData) {
        redirect();
        return;
      }
      state.isGetData = true;
    };
    if (isInIframe) {
      const isApiReturnOnFirstLoad = computed(() => store.state.isApiReturnOnFirstLoad);
      console.log('isApiReturnOnFirstLoad', isApiReturnOnFirstLoad.value);
      // 情境 1. iframe > 确认身份
      if (isApiReturnOnFirstLoad.value === true) {
        init();
      } else {
        const watcherIsLogin = watch(isApiReturnOnFirstLoad, async (newVal, oldVal) => {
          if (newVal) {
            init();
            watcherIsLogin(); // unwatch
          }
        });
      }
    } else {
      onBeforeMount(async () => {
        // 情境 2. popup > 确认验证码
        init();
      });
    }

    // 福米奖励
    const palcodeBonus = computed(() => store.getters['user/palcodeBonus']);
    // 我的邀请码 以及提交状态
    const myPlacode = computed(() => {
      const palcodeInfo = store.state.user.palcodeInfo;
      return {
        value: palcodeInfo.my_palcode,
        isGetRecommendedBonus: +palcodeInfo.status !== -1
      };
    });

    // ------------------------------------------------------------------
    // 关闭弹窗
    const close = () => {
      parent.postMessage({
        vueIframe: {
          elemtId: 'i-recommend',
          action: 'close'
        }
      }, '*');
      store.dispatch('common/showPalcodePopup', {
        show: false
      });
    };

    // ------------------------------------------------------------------
    // 提交邀请码
    async function applyPalcode() {
      var _response$body, _response$body2;
      if (!state.palcodeValue.trim()) {
        Toast('请输入邀请码');
        return;
      }
      const response = await API.applyPalcodeAPI({
        parent_palcode: state.palcodeValue
      });
      // success
      if ((response === null || response === void 0 ? void 0 : (_response$body = response.body) === null || _response$body === void 0 ? void 0 : _response$body.status) === 200) {
        await store.dispatch('user/getPalcodeInfo');
        state.tabValue = 1; // 切回预设值

        // 网址访问
        if (route.name === 'palcodePopup') {
          router.push({
            name: 'palcodeSuccessPopup'
          });
        } else {
          // 使用弹窗
          store.dispatch('common/showPalcodePopup', {
            show: false
          }); // 关闭弹窗
          store.dispatch('common/showPalcodeSuccessPopup'); // 显示通知弹窗
        }
      } else if (response !== null && response !== void 0 && (_response$body2 = response.body) !== null && _response$body2 !== void 0 && _response$body2.msg) {
        Toast(response.body.msg);
      }

      // 错误提示
      // body:
      //   msg: "请正确输入邀请码"
      //   status: -1
      //   msg: "不允许填入自己的邀请码"
      //   status: -1

      // 提出
      // body:
      //   msg: "待审核通过后，发放积分奖励"
      //   status: 200
      // head:
      //   cost: 0.758
      //   errCode: 0
      //   errMsg: "success"

      // 已完成
      // body:
      //   msg: "您已完成好友推荐"
      //   status: -1
      // head:
      //   cost: 0.688
      //   errCode: 0
      //   errMsg: "success"
    }

    return {
      state,
      myPlacode,
      palcodeBonus,
      applyPalcode,
      close
    };
  }
};